import { useEffect } from "react";
import { useWeatherState } from "../state/useWeatherState";
import { useLocation } from "./useLocation";

export function useLocationInit () {
  const getWeather = useWeatherState(state => state.getWeather)
  const { lat, lon, error } = useLocation();
  useEffect(() => {
		getWeather(error === null ? {lat, lon} : { lat: 45.0351532, lon: 38.9772396 });
	}, [getWeather, lat, lon, error]);
}